export default __webpack_public_path__ + "static/img-animoca-brands-7ad0ee6bbd4ecc1d62525dd4667baf44.png";